import { DacTabsComponent } from '@theme/dac-tabs';

/**
 * @typedef {Object} DacFeaturedCollectionsRefs
 * @property {HTMLElement} [tablist]
 * @property {HTMLButtonElement[]} tabs
 * @property {HTMLElement[]} panels
 * @property {HTMLAnchorElement} [viewAll]
 */

/**
 * Tabbed featured collections: extends shared dac-tabs and updates View all.
 * @extends {DacTabsComponent}
 */
class DacFeaturedCollectionsComponent extends DacTabsComponent {
  /**
   * After each tab sync, point the header View all link at the active collection.
   * @param {{ index: number, tab?: HTMLButtonElement, panel?: HTMLElement, animate: boolean }} detail
   */
  onTabsSynced(detail) {
    this.#syncViewAllFromPanel(detail.tab ?? detail.panel);
  }

  /**
   * Updates the header View all link from a tab or panel with data-collection-url.
   * @param {HTMLElement | undefined} source
   */
  #syncViewAllFromPanel(source) {
    const { viewAll } = this.refs;
    if (!(viewAll instanceof HTMLAnchorElement)) return;
    if (!viewAll.hasAttribute('data-dac-view-all')) return;

    const collectionUrl = source?.dataset?.collectionUrl;

    if (collectionUrl) {
      viewAll.href = collectionUrl;
      viewAll.removeAttribute('aria-disabled');
      viewAll.removeAttribute('role');
    } else {
      viewAll.removeAttribute('href');
      viewAll.setAttribute('role', 'link');
      viewAll.setAttribute('aria-disabled', 'true');
    }
  }
}

if (!customElements.get('dac-featured-collections-component')) {
  customElements.define('dac-featured-collections-component', DacFeaturedCollectionsComponent);
}
